/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  LandingPage,
  ErrorAndRetry,
  RemindLogin,
  RedirectPage,
  isTWId,
  Overlay,
  Loading,
  COLORS,
  formatNumberWithComma,
  ModulabIcon,
  ModulabIconNames,
} from '@hyphengroup/cag-components';
import { func, shape, string } from 'prop-types';
import { CustomerProfileContext } from 'containers/withCustomerProfileContext';
import Layout from 'components/layout';
import { LoginStates } from 'constants/login';
import Queries from 'queries';
import { withApollo, graphql } from 'react-apollo';
import ApplyLoanToSCB from 'money101/overrides/queries/applyLoanToSCB.gql';
import { getComponentConfigByLandingPage, validateLoanAmount } from './Utils';

const withApplyLoanToSCSubmission = graphql(ApplyLoanToSCB, {
  name: 'applyLoanToSCBMutation',
});

const LandingPageContent = ({
  data,
  staticTextList,
  imageAndLinkList,
  refetch,
  history,
  language,
  landingPageName,
  track,
  product,
  client,
  applyLoanToSCBMutation,
}) => {
  const currentPath = history.location.pathname;
  const email = data?.customerProfile?.customer?.email || '';
  const phoneNumber = data?.customerProfile?.customer?.phoneNumber?.phoneNumber || '';
  const countryCode = data?.customerProfile?.customer?.phoneNumber?.countryCode || '';
  const productId = product.id.substr(0, product.id.indexOf('_'));
  const landingPageDescData = getComponentConfigByLandingPage(data)[`${landingPageName}_LANDING_PAGE_DESC`];
  const landingPageFromData = getComponentConfigByLandingPage(data)[`${landingPageName}_LANDING_PAGE_FORM`];
  const [currentType, setCurrentType] = useState('password');

  const [nationalId, setNationalId] = useState('');
  const defaultLoanAmount = parseInt(landingPageFromData.textLists[3][2], 10) || 100000;
  const [loanAmount, setLoanAmount] = useState(defaultLoanAmount);
  const [checkTandC, setCheckTandC] = useState(true);

  const [isApplyLoading, setIsApplyLoading] = useState(false);
  const [isApplySuccess, setIsApplySuccess] = useState(false);
  const [isApplyError, setIsApplyError] = useState(false);
  const [cleanNationalIdInput, setCleanNationalIdInput] = useState(false);
  const [resData, setResData] = useState({});
  const [loginStatus, setLoginStatus] = useState(null);

  const heroBannerData = data?.heroBanner[0]?.text || [];
  const tncTitle = data?.termsAndCondition[0]?.text[0] || '';
  const tncData = (data?.termsAndCondition[0]?.text || []).filter((item, index) => index !== 0);

  const campaignName = staticTextList[`${landingPageName}_LANDING_PAGE_CAMPAIGN_NAME`];

  const loanAmountMin = parseInt(landingPageFromData.textLists[3][3], 10) || 100000;
  const loanAmountMax = parseInt(landingPageFromData.textLists[3][4], 10) || 3000000;

  const successLoginEvent = () => { window.location.href = currentPath; };

  const getRoundingValueByPosition = (value, position) => {
    const remainder = (value / position) % 1;
    if (remainder >= 0.5) return Math.ceil(value / position);
    return Math.floor(value / position);
  };

  const handlePasswordShownIconClick = () => {
    setCurrentType(currentType === 'password' ? 'text' : 'password');
  };

  const onHandlePopupEvent = (isOpen = false) => {
    if (isOpen) {
      track({
        data: {
          location: 'error page',
        },
      });
    } else {
      setCleanNationalIdInput(true);
      setNationalId('');
      track({
        data: {
          event: 'navigate',
          location: 'error page',
          componentType: 'button',
          action: 'click',
          title: 'close',
        },
      });
    }
  };

  const onHandlePopupRetryEvent = () => {
    track({
      data: {
        event: 'returnClick',
        location: 'error page',
        title: staticTextList?.LANDING_PAGE_ERROR_RETRY_CTA_TITLE,
      },
    });
  };

  const onHandleRemindSIgninEvent = (isSingin = false) => {
    if (isSingin) {
      track({
        data: {
          event: 'signupNow',
          location: 'rewards page',
          componentType: 'button',
          position: 1,
        },
      });
    } else {
      track({
        data: {
          event: 'login_rewards_redeem',
          location: 'rewards page',
          intent: 'skip reward',
        },
      });
    }
  };

  const onHandleIsLoggedInEvent = (isLoggedIn = false) => {
    if (isLoggedIn) {
      track({
        data: {
          location: 'login - rewards page',
          products: [{
            category: 'personal-loan',
            brand: product?.provider?.providerName || '',
            name: product?.productName || '',
            id: product?.title || '',
          }],
        },
      });
    } else {
      track({
        data: {
          location: 'rewards page',
          products: [{
            category: 'personal-loan',
            brand: product?.provider?.providerName || '',
            name: product?.productName || '',
            id: product?.title || '',
          }],
        },
      });
    }
  };

  const applyLoanApplication = () => {
    setIsApplyLoading(true);
    track({
      data: {
        event: 'login_rewards_redeem',
        location: 'login - rewards page',
        intent: 'lead form submitted',
        dashboardModule: 'rewards',
      },
    });
    client.query({
      query: Queries.GetApplicationTokenSeeded,
      variables: {
        seeds: [
          productId,
          campaignName,
        ],
      },
    }).then(({ data: { applicationToken } }) => applyLoanToSCBMutation({
      variables: {
        applicationToken,
        language,
        campaignName,
        input: {
          productId,
          loanDetails: {
            loanAmount: getRoundingValueByPosition(loanAmount, 10000),
            loanLength: -1,
          },
          plCustomer: {
            customer: {
              email,
              phoneNumber: {
                countryCode,
                phoneNumber,
              },
            },
            identityDocument: {
              identityDocumentType: 'TWID',
              identityDocumentValue: nationalId,
            },
          },
        },
        formVersionTag: '',
        formStageTag: '',
      },
    }))
      .then(({ data: { scbTwPlApplication } }) => {
        setIsApplyLoading(false);
        if (scbTwPlApplication?.success) {
          setResData({
            link: scbTwPlApplication?.redirectUrl || currentPath,
            sec: 5,
          });
          setIsApplySuccess(true);
        } else {
          setIsApplyError(true);
          onHandlePopupEvent(true);
        }
      }).catch(() => {
        setIsApplyLoading(false);
        setIsApplyError(true);
      });
  };

  useEffect(() => {
    if (loginStatus === LoginStates.LoggedOut) {
      onHandleIsLoggedInEvent();
      return;
    }
    if (loginStatus === LoginStates.LoggedIn) {
      onHandleIsLoggedInEvent(true);
    }
  }, [loginStatus]);

  if (isApplySuccess) {
    const dataWithoutLogoLink = data;
    if (data?.pageConfig?.header?.logo?.link) {
      dataWithoutLogoLink.pageConfig.header.logo.link = '#';
    }
    if (data?.pageConfig?.header?.menu?.menuItems) {
      dataWithoutLogoLink.pageConfig.header.menu.menuItems = [];
    }
    return (
      <Layout
        {...dataWithoutLogoLink?.pageConfig}
        componentConfig={dataWithoutLogoLink?.componentConfig}
        seoMetadata={dataWithoutLogoLink?.seoMetadata}
        customerProfile={dataWithoutLogoLink?.customerProfile}
        staticText={staticTextList}
        images={imageAndLinkList}
        isFooterShown={false}
        isAccountMenuHiddenOverride={true}
      >
        <RedirectPage
          header={staticTextList[`${landingPageName}_LANDING_PAGE_REDIRECT_HEADER`]}
          link={resData.link}
          sec={resData?.sec}
        />
      </Layout>
    );
  }
  return (
    <Layout
      {...data?.pageConfig}
      componentConfig={data?.componentConfig}
      seoMetadata={data?.seoMetadata}
      customerProfile={data?.customerProfile}
      staticText={staticTextList}
      images={imageAndLinkList}
      refetch={refetch}
      isFooterShown={data?.customerProfile?.loginState === LoginStates.LoggedIn}
      onSuccessEvent={successLoginEvent}
    >
      <CustomerProfileContext.Consumer>
        {({ showSignup, loginState }) => {
          setLoginStatus(loginState);
          if (loginState === LoginStates.LoggedOut) {
            return (
              <RemindLogin
                title={staticTextList?.LANDING_PAGE_REMIND_TITLE}
                subTitle={staticTextList?.LANDING_PAGE_REMIND_SUBTITLE}
                cancelCTA={{
                  text: staticTextList?.LANDING_PAGE_REMIND_CANCEL_CTA_TEXT,
                  onClick: () => {
                    onHandleRemindSIgninEvent();
                    window.location.href = (staticTextList[`${landingPageName}_LANDING_PAGE_REMIND_CANCEL_CTA_LINK`] || '#');
                  },
                }}
                confirmCTA={{
                  text: staticTextList?.LANDING_PAGE_REMIND_CONFIRM_CTA_TEXT,
                  onClick: () => {
                    showSignup();
                    onHandleRemindSIgninEvent(true);
                  },
                }}
              />
            );
          }
          return (
            <>
              <Overlay isOpen={isApplyLoading}>
                <Loading />
              </Overlay>
              <LandingPage
                heroBanner={{
                  exclusiveTitle: heroBannerData[0],
                  header: heroBannerData[1],
                  headerFeature: heroBannerData[2],
                  title: heroBannerData[3],
                  subTitle: heroBannerData[4],
                }}
                description={{
                  title: landingPageDescData?.text[0] || '',
                  features: (landingPageDescData?.textLists || []).map((item) => ({
                    title: item[0],
                    features: item.filter((listItem, index) => index !== 0),
                  })),
                }}
                formDetail={{
                  title: landingPageFromData.text[0] || '',
                  emailInput: {
                    defaultValue: email,
                    id: 'landing-form-email-input-id',
                    name: 'landing-form-email-input-name',
                    placeholder: landingPageFromData.textLists[0][0] || '',
                    onChange: () => { },
                    required: landingPageFromData.textLists[0][1].toUpperCase() === 'TRUE',
                    disabled: landingPageFromData.textLists[0][2].toUpperCase() === 'TRUE',
                    type: 'password',
                  },
                  phoneInput: {
                    defaultValue: phoneNumber,
                    id: 'landing-form-phone-input-id',
                    name: 'landing-form-phone-input-name',
                    placeholder: landingPageFromData.textLists[1][0] || '',
                    leftText: countryCode,
                    onChange: () => { },
                    required: landingPageFromData.textLists[1][1].toUpperCase() === 'TRUE',
                    disabled: landingPageFromData.textLists[1][2].toUpperCase() === 'TRUE',
                    type: 'password',
                  },
                  idCardInput: {
                    defaultValue: nationalId,
                    id: 'landing-form-national-input-id',
                    name: 'landing-form-national-input-name',
                    placeholder: landingPageFromData.textLists[2][0] || '',
                    onChange: (e) => {
                      setNationalId(e.value);
                      if (cleanNationalIdInput) {
                        setCleanNationalIdInput(false);
                      }
                    },
                    required: landingPageFromData.textLists[2][1].toUpperCase() === 'TRUE',
                    disabled: landingPageFromData.textLists[2][2].toUpperCase() === 'TRUE',
                    maxLength: 10,
                    country: 'tw',
                    errorMessage: landingPageFromData.textLists[2][3] || '',
                    requiredText: landingPageFromData.textLists[2][4] || '',
                    showValidationMessageOnChange: true,
                    valueCleanFlag: cleanNationalIdInput,
                    type: currentType,
                    rightIcon:
                      (<ModulabIcon
                        iconName={
                          currentType === 'password'
                            ? ModulabIconNames.VISIBLE
                            : ModulabIconNames.HIDDEN
                        }
                        onClick={handlePasswordShownIconClick}
                        iconSize={3}
                        dataSelectorId="landing-form-national-input-id-passwordShownIcon"
                        marginRight="16px"
                      />),
                  },
                  idCardError: landingPageFromData.textLists[2][3] || '',
                  idCardInputValue: nationalId,
                  loanAmount: {
                    title: landingPageFromData.textLists[3][0] || '',
                    input: {
                      pattern: '^[0-9]*$',
                      prefixText: landingPageFromData.textLists[3][1] || '',
                      preFormatter: (value) => value.replace(/,/g, ''),
                      postFormatter: formatNumberWithComma,
                      onChange: (e) => setLoanAmount(parseInt(e.target.value.replace(/,/g, ''), 10) || 0),
                      squareInputStyle: {
                        color: COLORS.GREY_HOVER,
                      },
                      status: !validateLoanAmount(loanAmount, loanAmountMin, loanAmountMax) ? 'error' : '',
                      helperText: !validateLoanAmount(loanAmount, loanAmountMin, loanAmountMax) ? landingPageFromData.textLists[3][6] : '',
                    },
                    slider: {
                      min: loanAmountMin,
                      max: loanAmountMax,
                      step: parseInt(landingPageFromData.textLists[3][5], 10) || 100000,
                      onChange: (value) => setLoanAmount(value),
                      thumbColor: COLORS.BLUE,
                    },
                  },
                  loanAmountValue: loanAmount,
                  checkBox: {
                    id: 'landing-form-checkbox-id',
                    name: 'landing-form-checkbox-name',
                    value: 'check-default-value',
                    onChange: () => {
                      setCheckTandC((value) => !value);
                    },
                    children: landingPageFromData.textLists[4][0] || '',
                    checked: checkTandC,
                  },
                  checkboxLabel: landingPageFromData.textLists[4][0] || '',
                  checkboxValue: checkTandC,
                  submit: {
                    text: landingPageFromData.textLists[5][0] || '',
                    onClick: () => applyLoanApplication(),
                    disabled: nationalId === '' || !checkTandC || !isTWId(nationalId) || isApplyLoading || !validateLoanAmount(loanAmount, loanAmountMin, loanAmountMax),
                  },
                }}
                tandCDetail={{
                  title: tncTitle,
                  list: tncData,
                }}
              />
              <ErrorAndRetry
                isOpen={isApplyError}
                heroImage={{
                  title: '',
                  url: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blte31ef74bf48e5409/60892ff0162d47104df491d2/ERROR_MESSAGE.svg?disposition=inline',
                }}
                header={staticTextList?.LANDING_PAGE_ERROR_HEADER}
                RetryCTA={{
                  content: staticTextList?.LANDING_PAGE_ERROR_RETRY_CTA_TITLE,
                  onClick: () => {
                    setIsApplyError(false);
                    applyLoanApplication();
                    onHandlePopupRetryEvent();
                  },
                }}
                BackCTA={{
                  content: staticTextList?.LANDING_PAGE_ERROR_BACK_CTA_TITLE,
                  onClick: () => {
                    setIsApplyError(false);
                    onHandlePopupEvent();
                  },
                }}
                onClose={() => {
                  setIsApplyError(false);
                  onHandlePopupEvent();
                }}
              />
            </>
          );
        }}
      </CustomerProfileContext.Consumer>

    </Layout>
  );
};

LandingPageContent.propTypes = {
  data: shape({}),
  staticTextList: shape({}),
  imageAndLinkList: shape({}),
  refetch: func,
  history: shape({}).isRequired,
  language: string,
  landingPageName: string,
  track: func.isRequired,
  product: shape({}),
};

LandingPageContent.defaultProps = {};

export default withApplyLoanToSCSubmission(withApollo(LandingPageContent));
